import useAudioTemplateFlow from './useAudioTemplateFlow';

export default useAudioTemplateFlow;
